import { render, staticRenderFns } from "./ModalProgrammedPackageV2.vue?vue&type=template&id=ed766a48&"
import script from "./ModalProgrammedPackageV2.vue?vue&type=script&lang=js&"
export * from "./ModalProgrammedPackageV2.vue?vue&type=script&lang=js&"
import style0 from "./ModalProgrammedPackageV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports